module.exports = __webpack_public_path__ + "static/img/CL.41bacea5.jpg";